import { useTrEnumNamespace as e } from "./useTrEnumNamespace.mjs";
//#region src/enums/useTrCsatFeature.ts
var t = () => e("csatFeature");
//#endregion
export { t as useTrCsatFeature };
